import { take, of } from 'rxjs';
import type { Observable } from 'rxjs';

import { FlightEndpoint } from '@apps/main/modules/api/flight';

import type { AirportStaticInfo } from '@libs/trip-planner-interfaces';
import type { Coordinate } from '@libs/maps';

export function getSuggestedAirport(
  searchTerm: string | Coordinate | undefined,
  searchEnpoint = new FlightEndpoint()
): Observable<AirportStaticInfo | undefined> {
  if (searchTerm === undefined) {
    return of(undefined);
  }
  return searchEnpoint.getSuggestedAirport(searchTerm).pipe(take(1));
}
